import { Component } from '@angular/core';

@Component({
  selector: 'app-background-decoration',
  templateUrl: './background-decoration.component.html',
  standalone: true,
})
export class BackgroundDecorationComponent {}
